import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ManufacturersQuery = gql`
    query {
        manufacturers {
            id
            name
            description
            manufacturerImage {
                id
                file
            }
        }
    }
`;

const CreateManufacturerMutation = gql`
    mutation($manufacturer: ManufacturerInput!) {
        createManufacturer(manufacturer: $manufacturer) {
            id
        }
    }
`;

const UpdateManufacturerMutation = gql`
    mutation($id: String!, $manufacturer: ManufacturerInput!) {
        updateManufacturer(id: $id, manufacturer: $manufacturer) {
            id
        }
    }
`;

const DeleteManufacturerMutation = gql`
    mutation($id: String!) {
        deleteManufacturer(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
}

interface Response {
    data: any;
}

class GetManufacturersQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { manufacturers, createManufacturer, updateManufacturer, deleteManufacturer }: any = this.props;
        return this.props.children({
            manufacturers,
            createManufacturer,
            updateManufacturer,
            deleteManufacturer
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(ManufacturersQuery, {
        name: 'manufacturers'
    }),
    graphql<IInputProps, Response>(CreateManufacturerMutation, {
        name: 'createManufacturer'
    }),
    graphql<IInputProps, Response>(UpdateManufacturerMutation, {
        name: 'updateManufacturer'
    }),
    graphql<IInputProps, Response>(DeleteManufacturerMutation, {
        name: 'deleteManufacturer'
    })
)(GetManufacturersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Manufacturers/Manufacturers.tsx